import { Button, Divider, Empty } from "antd";
import CartProductItem from "./CartProductItem";
import { useGetCart, useGetCartTotalValue } from "services/cart";
import useUserStore from "stores/user";
import { ICartItem } from "types/cart";
import { Link } from "react-router-dom";

const CartDrawerContent = () => {
  const { user } = useUserStore();
  const { cartItemList, isLoading } = useGetCart(user);
  const { totalValue } = useGetCartTotalValue();

  if (isLoading) {
    return <div>Loading</div>;
  }
  if (!cartItemList) {
    return (
      <div>
        <Empty
          description={
            <div>
              <div className="text-black font-semibold text-xl">
                ไม่มีสินค้าในตะกร้า
              </div>
            </div>
          }
        />
      </div>
    );
  }
  // Separate items into regular products and redemption items
  const regularProducts = cartItemList.filter(
    (item) => !item.redemptionItemId || !item.redemptionItem
  );
  const redemptionItems = cartItemList.filter(
    (item) => item.redemptionItemId && item.redemptionItem
  );

  return (
    <div>
      <div className="flex justify-between">
        <div className="text-xl">ตะกร้าสินค้า ({cartItemList.length})</div>
      </div>
      <Divider />
      {cartItemList.length === 0 ? (
        <Empty
          description={
            <div>
              <div className="text-black font-semibold text-xl">
                ไม่มีสินค้าในตะกร้า
              </div>
            </div>
          }
        />
      ) : (
        <>
          {/* Products Section */}
          {regularProducts.length > 0 && (
            <div className="mb-6">
              <div className="text-lg font-semibold text-gray-800 mb-3 flex items-center">
                <span className="mr-2">🛍️</span>
                สินค้า ({regularProducts.length})
              </div>
              {regularProducts.map((cartItem: ICartItem) => (
                <CartProductItem
                  key={cartItem.id}
                  itemId={cartItem.id}
                  url={cartItem.productPrice?.product.images[0] || ""}
                  name={cartItem.productPrice?.product.name || ""}
                  qty={cartItem.quantity}
                  price={cartItem.productPrice?.price || "0"}
                  productId={cartItem.productPrice?.productId || 0}
                  isRedemptionItem={false}
                  productCode={cartItem.productPrice?.product.productCode}
                />
              ))}
            </div>
          )}

          {/* Redemption Items Section */}
          {redemptionItems.length > 0 && (
            <div className="mb-6">
              {regularProducts.length > 0 && (
                <div className="border-t border-gray-200 my-4"></div>
              )}
              <div className="text-lg font-semibold text-purple-600 mb-3 flex items-center">
                <span className="mr-2">🎁</span>
                สินค้าแลกคะแนน ({redemptionItems.length})
              </div>
              {redemptionItems.map((cartItem: ICartItem) => (
                <CartProductItem
                  key={cartItem.id}
                  itemId={cartItem.id}
                  url={cartItem.redemptionItem!.images?.[0] || ""}
                  name={cartItem.redemptionItem!.name}
                  qty={cartItem.quantity}
                  price={cartItem.redemptionItem!.cashCost?.toString() || "0"}
                  productId={0} // No product ID for redemption items
                  isRedemptionItem={true}
                  redemptionItem={cartItem.redemptionItem}
                />
              ))}
            </div>
          )}

          <div className="flex justify-between font-semibold bg-[#D4B5F430] py-4 mx-[-24px] px-6">
            <span>รวมทั้งหมด</span>
            <span>{totalValue.toLocaleString()} บาท</span>
          </div>

          <div className="flex justify-center mt-8">
            <Link to={"/cart"}>
              <Button type="primary" size="large" className="px-10">
                ไปที่หน้าตะกร้า
              </Button>
            </Link>
          </div>
        </>
      )}
    </div>
  );
};
export default CartDrawerContent;
